module.exports = __webpack_public_path__ + "media/images/admin/icons/cloud-rain-d2464f1a0526d4c55e659d05e2009270.svg";